export const name: string = 'Widget Accordion';
export const group = 'Layout';
export const moduleName: string = 'pdc-widget-accordion';
export const icon: string = 'folder-close';
export const themeId: string = 'widget-accordion';
export const namespace: string = 'business-intelligence';

export const themeFields = {
    accordionMode: 'widget-accordion-mode',
    tabTextColor: 'widget-accordion-tab-text-color',
    tabBackgroundColor: 'widget-accordion-tab-background-color',
    tabBorderRadius: 'widget-accordion-tab-border-radius',
    widgetBlockBorderWidth: 'widget-accordion-widget-block-border-width',
    widgetBlockBorderColor: 'widget-accordion-widget-block-border-color',
    widgetBlockBorderRadius: 'widget-accordion-widget-block-border-radius',
    widgetContainerHeight: 'widget-accordion-widget-container-height'
};

export const DEFAULT_CONTAINER_HEIGHT = 300;